import styled from '@emotion/styled';
import { Alert, alpha } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const StyledAlert = styled(Alert)(
  {
    marginTop: 12,
  },
  ({ theme }) => {
    if (theme.isDark) {
      return {
        backgroundColor: alpha(theme.palette.warning.dark, 0.3),
      };
    }
  },
  ({ theme }) => {
    if (theme.isDark && theme.palette.isHighContrast) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      };
    }
  },
);

const ModelDeactivatedWarning = () => (
  <StyledAlert severity="warning">
    <FormattedMessage id="editor.model_editor.model_selector.model_settings.dialog.default_controls.deactivated_model_warning" />
  </StyledAlert>
);

export default ModelDeactivatedWarning;
